import PageCommon from "./PageCommon.js";

export default class PageIntro extends PageCommon {
	constructor() {
		super();

		// this.settaAncheGdpr = false;
	}
	init($data) {
		super.init($data);
		this.data = $data;
		this.showPreloader(false);

		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);

		$(".mcSi").on("click", (event) => {
			// console.log(1)
			jQuery.cookie("IM", "accepted", { expires: 48, path: "/" });
			// jQuery.cookie("cb-enabled", "accepted", { expires: 48, path: "/" });
			//alert(jQuery.cookie("IM"))
			//alert(this.data.u)
			if (this.data.u && this.data.u != "") {
				window.location.href = this.data.u;
			}
			else {
				window.location.href = TheApp.Env.BaseUrlNls + "home";
			}
		});

		document.querySelector(".mcNo").addEventListener("click", (event) => {
			window.open("https://disney.it/");
		});


		// dispaccio un evento globale
		try {
			this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
		}
		catch {
			console.error()
		}
	}
}
